import confetti from "canvas-confetti";
import { CUSTOM_EVENTS } from "../cfg/constants/game-constants";
export class GameScreen {
    getRandomQuestions(count = 5) {
        // Get the full question bank
        const fullQuestionBank = this.scene.cache.json.get("gameData");
        //make sure every question, correct answers, wrong answers, info answers, check answers with links are in the same index
        // Create a copy of indices array
        const indices = Array.from({ length: fullQuestionBank.questionArr.length }, (_, i) => i);
        // Shuffle indices
        const shuffledIndices = this.shuffleArray([...indices]);
        // Take only the first 'count' indices
        const selectedIndices = shuffledIndices.slice(0, count);
        // Create new question bank with only selected questions
        this.questionBank = {
            questionArr: selectedIndices.map((i) => fullQuestionBank.questionArr[i]),
            correctAnswers: selectedIndices.map((i) => fullQuestionBank.correctAnswers[i]),
            wrongAnswers: selectedIndices.map((i) => fullQuestionBank.wrongAnswers[i]),
            infoAnswers: selectedIndices.map((i) => fullQuestionBank.infoAnswers[i]),
            checkAnswersWithLinks: selectedIndices.map((i) => fullQuestionBank.checkAnswersWithLinks[i]),
            timerDuration: fullQuestionBank.timerDuration,
        };
    }
    constructor(scene) {
        this.scene = scene;
        this.picAnswerArr = ["Anil", "Women", "Tennis"];
        this.picWrongAnswerArr = ["Lewis", "Mukesh", "Novak"];
        this.isPicMode = false;
        this.questionArr = [];
        this.correctAnswers = [];
        this.wrongAnwers = [];
        this.checkAnswersWithLinks = [];
        this.infoAnswers = [];
        this.totalQuestions = 5;
        this.randomizedArray = [];
        this.imageOptionsArr = [];
        this.boxSize = 325;
        this.boxScale = 1.3;
        this.startX = 0;
        this.startY = 0;
        this.score = 0;
        this.totalBoxsClicked = 0;
        this.boxArr = [];
        this.longButtonArr = [];
        this.longButtonGraphicsArr = [];
        this.longButtonTextArr = [];
        this.boxTextArr = [];
        this.noOfMistakesRemaining = 2;
        this.noOfWordsToSelect = 3;
        this.submitButtonPhase = "Submit";
        this.isButtonPressed = false;
        this.timerDuration = 57000;
        this.questionNumber = 1;
        this.gameTry = 1;
        this.mistakeDotsArr = [];
        this.questionBank = [];
        this.isNextButtonPressedOk = false;
        this.m = 2;
        this.n = 3;
        this.xOffset = 1.3;
        this.yOffset = 2.3;
        this.isSoundOn = true;
        this.isMobile = false;
        this.colorCode = {
            gameHeadingText: "#ffffff",
            tutorialTextHeading: "#000000",
            timeText: "#ffffff",
            mistakesText: "#000000",
            submitButtonText: "#ffffff",
            feedbackButtonHex: 0x2c47d0,
            playAnotherRoundButtonHex: 0xfedbd0,
            playAnotherRoundButtonTextHex: "#442c2E",
            longButtonHex: 0x4b9344,
            longButtonTextHex: "#ffffff",
            unSelectedBoxHex: 0x2c47d0,
            unSelectedBoxTextHex: "#ffffff",
            selectedBoxHex: 0xf4b941,
            selectedBoxTextHex: "#000000",
            correctAnswerBoxHex: 0x4b9344,
            correctAnswerBoxTextHex: "#000000",
            bottomBoxTextHex: "#ffffff",
            endTextThankYouHex: "#ffffff",
        };
        this.isTimerRed = false;
        this.getRandomQuestions();
        this.totalQuestions = this.questionBank.questionArr.length;
        const indices = Array.from({ length: this.questionBank.questionArr.length }, (_, i) => i);
        const shuffledIndices = this.shuffleArray([...indices]);
        // Use shuffled indices to reorder arrays while maintaining relationships
        this.questionArr = shuffledIndices.map((i) => this.questionBank.questionArr[i]);
        this.correctAnswers = shuffledIndices.map((i) => this.questionBank.correctAnswers[i]);
        this.infoAnswers = shuffledIndices.map((i) => this.questionBank.infoAnswers[i]);
        this.checkAnswersWithLinks = shuffledIndices.map((i) => this.questionBank.checkAnswersWithLinks[i]);
        this.wrongAnwers = shuffledIndices.map((i) => this.questionBank.wrongAnswers[i]);
        this.timerDuration = this.questionBank.timerDuration;
        this.scene.globalEvents.on(CUSTOM_EVENTS.RESET_GAME, () => {
            this.ResetGame();
        });
        // this.totalQuestions = data.totalQuestions;
        if (this.getMobileOperatingSystem() != "unknown") {
            this.isMobile = true;
        }
        this.leftBG1 = this.scene.add
            .image(-2000, 0, "bg1")
            .setScale(5)
            .setDepth(999);
        this.rightBG1 = this.scene.add
            .image(2000, 0, "bg1")
            .setScale(5)
            .setDepth(999);
        this.topLogo = this.scene.add
            .image(-250, -600, "varsityLogo")
            .setScale(0.2)
            .setVisible(false);
        this.bottomLogo = this.scene.add.image(300, 600, "PPPLogo").setScale(0.05);
        if (this.isMobile) {
            this.leftBG1.setVisible(false);
            this.rightBG1.setVisible(false);
        }
        // if(this.isPicMode) this.totalQuestions = 1;
        this.isAnimationRunning = true;
        let style1 = {
            font: "45px Arial",
        };
        this.questionBox = this.scene.add
            .sprite(0, 0, "button2")
            .setScale(2.5)
            .setVisible(false);
        this.boxSize = this.questionBox.scaleX * this.questionBox.width * 0.45;
        // this.gameHintHeadingText = this.scene.add.text(0,this.questionBox.y - this.questionBox.scaleY*this.questionBox.height*0.40, this.questionArr[this.questionNumber-1], style1).setOrigin(0.5);
        // this.gameHintHeadingText.setColor(this.colorCode.gameHeadingText)
        // this.gameHintHeadingText.setFontFamily("GameFont");
        // this.gameHintHeadingText.setFontSize("45px");
        this.scene.anims.create({
            key: "button_click",
            frames: [{ key: "buttonCircle1" }, { key: "buttonCircle" }],
            frameRate: 8,
            repeat: 0,
        });
        this.soundButton = this.scene.add
            .sprite(-300, -575, "SoundOn")
            .setVisible(true)
            .setScale(0.6)
            .setInteractive()
            .setVisible(false);
        this.soundButton.on("pointerup", () => {
            this.isSoundOn = !this.isSoundOn;
            if (this.isSoundOn)
                this.soundButton.setTexture("SoundOn");
            else
                this.soundButton.setTexture("SoundOff");
        });
        let questionHeadingStyle = {
            font: "60px GameFontBold",
            stroke: "#000000",
            strokeThickness: 5,
            shadow: {
                offsetX: 0,
                offsetY: 1,
                color: "#ffffff",
                blur: 0,
                stroke: true,
                fill: false,
            },
        };
        this.gameHintHeadingText = this.scene.add
            .text(0, this.questionBox.y -
            this.questionBox.scaleY * this.questionBox.height * 0.4, this.questionArr[this.questionNumber - 1], questionHeadingStyle)
            .setOrigin(0.5);
        if (this.questionArr[this.questionNumber - 1].length > 20) {
            this.gameHintHeadingText.setFontSize(45);
        }
        else {
            this.gameHintHeadingText.setFontSize(60);
        }
        this.randomizedArray = this.generateOptions();
        this.elapsedTime = this.timerDuration || 60000 * 2;
        this.isRunning = true;
        this.tutorialIcon = this.scene.add
            .sprite(285, this.questionBox.y +
            this.questionBox.scaleY * this.questionBox.height * 0.55, "question")
            .setScale(0.8)
            .setInteractive()
            .setVisible(true)
            .setVisible(false);
        this.questionPopup = this.scene.add
            .sprite(0, -25, "popup")
            .setScale(1.8)
            .setDepth(999)
            .setVisible(false)
            .setScale(0.7);
        this.closeButton = this.scene.add
            .sprite(this.questionPopup.x +
            this.questionPopup.scaleX * this.questionPopup.width * 0.4, this.questionPopup.y -
            this.questionPopup.scaleY * this.questionPopup.height * 0.35, "closeButton")
            .setScale(0.15)
            .setDepth(999)
            .setVisible(false)
            .setInteractive();
        // this.tutorialTextHeading = this.scene.add.text(this.questionPopup.x, this.questionPopup.y - 250, 'TUTORIAL', {
        // 	font: '32px Arial',
        // }).setOrigin(0.5).setVisible(false).setDepth(999);
        // this.tutorialTextHeading.setColor(this.colorCode.tutorialTextHeading);
        // this.tutorialText = this.scene.add.text(this.questionPopup.x-285, this.questionPopup.y, '* Choose the three news items\n   connected to the #trend\n\n* The correct options are directly\n    relevant to the manu trending word, and\n   appeared together in news reports.\n\n* The trend connections are at\n   the discretion of the editor', {
        // 	font: '37px Arial',
        // 	align:"left",
        // }).setOrigin(0,0.5).setVisible(false).setDepth(999);
        // this.tutorialText.setFontFamily("GameFontMedium")
        // this.tutorialText.setColor(this.colorCode.tutorialTextHeading);
        this.tutorialIcon.on("pointerup", () => {
            this.timer.paused = true;
            // 	this.tutorialText.setVisible(!this.questionPopup.visible);
            this.closeButton.setVisible(!this.closeButton.visible);
            // 	this.tutorialTextHeading.setVisible(!this.questionPopup.visible);
            this.questionPopup.setVisible(!this.questionPopup.visible);
        });
        this.closeButton.on("pointerup", () => {
            this.timer.paused = false;
            // 	this.tutorialText.setVisible(!this.questionPopup.visible);
            this.closeButton.setVisible(!this.closeButton.visible);
            // 	this.tutorialTextHeading.setVisible(!this.questionPopup.visible);
            this.questionPopup.setVisible(!this.questionPopup.visible);
        });
        this.timerBG = this.scene.add
            .sprite(0, -515, "timerbg")
            .setVisible(true)
            .setScale(0.6);
        this.timeText = this.scene.add
            .text(this.timerBG.x + 25, this.timerBG.y - 10, "00:00", {
            fontSize: "32px",
        })
            .setOrigin(0.5);
        this.timeText.setColor(this.colorCode.timeText);
        this.originalTimeTextColor = this.colorCode.timeText;
        this.timeText.setFontFamily("GameFontBold");
        this.isRunning = !this.isRunning;
        this.timer = this.scene.time.addEvent({
            delay: 100,
            callback: this.updateStopwatch,
            callbackScope: this,
            loop: true,
        });
        this.updateTimeDisplay();
        this.pauseTimer();
        const style2 = {
            font: "30px Dimbo",
        };
        this.mistakesText = this.scene.add
            .text(-50, this.questionBox.y -
            this.questionBox.scaleY * this.questionBox.height * 0.6, "Mistakes remaining:", style2)
            .setOrigin(0.5)
            .setVisible(false)
            .setAlpha(0);
        this.mistakesText.setColor(this.colorCode.mistakesText);
        this.mistakeDotsArr = [];
        for (let i = 0; i < this.noOfMistakesRemaining; i++) {
            const dot = this.scene.add
                .sprite(this.mistakesText.x + 250 + i * 75, this.mistakesText.y, "dot")
                .setScale(0.2);
            dot.setTint(0xff0000);
            this.mistakeDotsArr.push(dot);
        }
        const buttonConfig = {
            font: "25px Arial",
        };
        this.submitButton = this.scene.add
            .sprite(0, 475, "buttonCircle")
            .setScale(0.7)
            .setInteractive()
            .setAlpha(0.5);
        this.submitButtonText = this.scene.add
            .text(this.submitButton.x, this.submitButton.y - 10, "Submit", buttonConfig)
            .setOrigin(0.5)
            .setVisible(false);
        this.submitButtonText.setColor(this.colorCode.submitButtonText);
        this.submitButtonText.setAlpha(0);
        this.nextButton = this.scene.add
            .sprite(0, 475, "next")
            .setScale(0.7)
            .setInteractive()
            .setAlpha(1)
            .setVisible(false);
        this.submitButtonText.setFontFamily("GameFontMedium");
        this.belowText = this.scene.add
            .sprite(0, 340, "clickBoxReadMore")
            .setScale(0.7)
            .setInteractive()
            .setAlpha(1)
            .setVisible(false);
        // this.belowText = this.scene.add.text(0, 440, 'Click on the boxes to read more', style2).setOrigin(0.5).setVisible(false);
        // this.belowText.setColor(this.colorCode.bottomBoxTextHex)
        // this.belowText.setAlign("center");
        this.submitButton.on("pointerup", () => this.checkAnswer());
        //End screen Elements
        this.endInstructionPopup = this.scene.add
            .sprite(0, -50, "endPopup")
            .setScale(0.7)
            .setInteractive()
            .setDepth(999);
        this.endLogo = this.scene.add
            .sprite(0, -100, "logo")
            .setScale(0.5)
            .setInteractive()
            .setDepth(-1);
        this.endText1 = this.scene.add
            .text(0, this.endInstructionPopup.y -
            this.endInstructionPopup.scaleY *
                this.endInstructionPopup.height *
                0.05, "Congratulations!\n\nYou Answered\n\n", style2)
            .setOrigin(0.5)
            .setVisible(true)
            .setDepth(999);
        this.endText1.setColor(this.colorCode.endTextThankYouHex);
        this.endText1.setAlign("center");
        this.endText1.setFontSize("70px");
        this.endText1.setFontFamily("GameFont");
        this.endText2 = this.scene.add
            .text(0, this.endInstructionPopup.y +
            this.endInstructionPopup.scaleY *
                this.endInstructionPopup.height *
                0.1, "2/5", style2)
            .setOrigin(0.5)
            .setVisible(true)
            .setDepth(999);
        this.endText2.setColor(this.colorCode.endTextThankYouHex);
        this.endText2.setAlign("center");
        this.endText2.setFontSize("70px");
        this.endText2.setFontFamily("GameFont");
        this.endText3 = this.scene.add
            .text(0, this.endInstructionPopup.y +
            this.endInstructionPopup.scaleY *
                this.endInstructionPopup.height *
                0.3, "Grab Your prize", style2)
            .setOrigin(0.5)
            .setVisible(true)
            .setDepth(999);
        this.endText3.setColor(this.colorCode.endTextThankYouHex);
        this.endText3.setAlign("center");
        this.endText3.setFontSize("70px");
        this.endText3.setFontFamily("GameFont");
        const endButtonConfig = {
            font: "45px Arial",
        };
        this.EndnextButton = this.scene.add
            .sprite(0, this.endInstructionPopup.y +
            this.endInstructionPopup.scaleY *
                this.endInstructionPopup.height *
                0.5, "next_g")
            .setScale(0.7)
            .setInteractive()
            .setAlpha(1)
            .setVisible(false)
            .setDepth(999);
        this.EndnextButtonText = this.scene.add
            .text(this.EndnextButton.x, this.EndnextButton.y - 10, "Next", endButtonConfig)
            .setOrigin(0.5)
            .setVisible(false);
        this.twitterLogo = this.scene.add
            .image(-150, 575, "twitterLogo")
            .setScale(0.5)
            .setDepth(1000)
            .setVisible(false)
            .setInteractive();
        this.facebookLogo = this.scene.add
            .image(0, 575, "facebookLogo")
            .setScale(0.5)
            .setDepth(1000)
            .setVisible(false)
            .setInteractive();
        this.instagramLogo = this.scene.add
            .image(150, 575, "instagramLogo")
            .setScale(0.5)
            .setDepth(1000)
            .setVisible(false)
            .setInteractive();
        this.twitterLogo.on("pointerup", () => {
            window.open("https://twitter.com/", "_blank");
        });
        this.facebookLogo.on("pointerup", () => {
            window.open("https://www.facebook.com/", "_blank");
        });
        this.instagramLogo.on("pointerup", () => {
            window.open("https://www.instagram.com/", "_blank");
        });
        this.EndnextButton.on("pointerup", () => {
            // Reset game state
            // this.scene.scene.restart();
            this.submitButtonPhase = "";
            window.location.reload();
            // this.endInstructionPopup.setVisible(false);
            // this.endLogo.setVisible(false);
            // this.endText1.setVisible(false);
            // this.endText2.setVisible(false);
            // this.endText3.setVisible(false);
            // this.feedbackButton.setVisible(false);
            // this.EndnextButton.setVisible(false);
            // this.playAnotherRoundButton.setVisible(false);
            // this.twitterLogo.setVisible(false);
            // this.facebookLogo.setVisible(false);
            // this.instagramLogo.setVisible(false);
            // this.boxArr.forEach((box)=>{
            // 	box.isSelected = false;
            // 	box.isCorrectAnswered = false;
            // 	box.setPosition(box.tweenXpos,box.orgPosY);
            // 	box.boxText.setPosition(box.x,box.y);
            // })
            // this.scene.globalEvents.emit(CUSTOM_EVENTS.SHOW_START_SCREEN);
            // window.location.reload();
            return;
        });
        this.feedbackButton = this.scene.add
            .sprite(0, 300, "share")
            .setScale(0.7)
            .setInteractive();
        //  this.feedbackButtonText = this.scene.add.text(this.feedbackButton.x, this.feedbackButton.y, 'Do share your\n feedback', buttonConfig).setOrigin(0.5);
        //  this.feedbackButton.setTint(this.colorCode.feedbackButtonHex);
        this.playAnotherRoundButton = this.scene.add
            .sprite(0, 250, "play_again")
            .setScale(0.7)
            .setInteractive();
        //  this.playAnotherRoundButtonText = this.scene.add.text(this.playAnotherRoundButton.x, this.playAnotherRoundButton.y, 'Play another round', buttonConfig).setOrigin(0.5);
        //  this.playAnotherRoundButton.setTint(this.colorCode.playAnotherRoundButtonHex);
        //  this.playAnotherRoundButtonText.setColor(this.colorCode.playAnotherRoundButtonTextHex)
        this.endInstructionPopup.setVisible(false);
        this.endLogo.setVisible(false);
        this.endText1.setVisible(false);
        this.endText2.setVisible(false);
        this.endText3.setVisible(false);
        this.feedbackButton.setVisible(false);
        this.playAnotherRoundButton.setVisible(false);
        this.feedbackButton.on("pointerup", () => {
            gtag("event", "feedback_btn", {
                screen_name: "end_page",
            });
            window.open("https://forms.gle/qhtoNBAJzrmyMApTA", "_blank");
        });
        this.playAnotherRoundButton.on("pointerup", () => {
            gtag("event", "play_again_btn", {
                screen_name: "end_page",
            });
            console.log("here");
            // this.restartGame();
            window.location.reload();
            // this.gameTry++;
            // if(this.gameTry <=2){
            // 	this.setVisibleAll(true);
            // 	this.OnNextButtonPressed();
            // 		this.totalQuestions =6;
            // 		this.endInstructionPopup.setVisible(false);
            // 		this.endLogo.setVisible(false);
            // 		this.endText1.setVisible(false);
            // 		this.endText2.setVisible(false);
            // 		this.feedbackButton.setVisible(false);
            // 		this.playAnotherRoundButton.setVisible(false);
            // } else{
            // }
        });
    }
    ResetGame() {
        this.gameTry++;
        this.resetStopwatch();
        this.setVisibleAll(true);
        this.questionNumber = 0;
        if (this.questionBank.length < 5) {
            this.questionBank = this.scene.cache.json.get("gameData");
        }
        this.getRandomQuestions();
        this.totalQuestions = this.questionBank.questionArr.length;
        this.score = 0;
        console.log(this.questionBank);
        const indices = Array.from({ length: this.questionBank.questionArr.length }, (_, i) => i);
        const shuffledIndices = this.shuffleArray([...indices]);
        // Use shuffled indices to reorder arrays while maintaining relationships
        this.questionArr = shuffledIndices.map((i) => this.questionBank.questionArr[i]);
        this.correctAnswers = shuffledIndices.map((i) => this.questionBank.correctAnswers[i]);
        this.infoAnswers = this.questionBank.infoAnswers;
        this.checkAnswersWithLinks = this.questionBank.checkAnswersWithLinks;
        this.wrongAnwers = shuffledIndices.map((i) => this.questionBank.wrongAnswers[i]);
        this.OnNextButtonPressed();
    }
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }
    restartGame() {
        this.cleanup();
        this.scene.scene.restart();
    }
    cleanup() {
        var _a;
        // Destroy all game objects
        (_a = this.boxArr) === null || _a === void 0 ? void 0 : _a.forEach((box) => {
            var _a;
            (_a = box.boxText) === null || _a === void 0 ? void 0 : _a.destroy();
            box.destroy();
        });
        this.boxArr = [];
        // Clear arrays and reset game state
        // this.selectedBoxes = [];
        // this.unselectedBoxes = [];
        this.questionArr = [];
        this.correctAnswers = [];
        this.wrongAnwers = [];
        // Reset game variables
        this.questionNumber = 0;
        this.noOfMistakesRemaining = 4;
        this.isRunning = false;
        this.isPicMode = false;
        // Cleanup UI elements
        this.deactivateConfetti();
        this.ClearAllMask();
        this.resetStopwatch();
    }
    triggerConfetti() {
        const confettiContainer = document.getElementById("confetti-container");
        if (confettiContainer) {
            // Create a canvas element
            const canvas = document.createElement("canvas");
            canvas.style.position = "absolute";
            canvas.style.top = "-35%";
            canvas.style.left = "0";
            canvas.style.width = "100%";
            canvas.style.height = "100%";
            canvas.style.pointerEvents = "none";
            canvas.style.zIndex = "9999";
            // Append the canvas to the confetti container
            confettiContainer.appendChild(canvas);
            // Trigger confetti on the canvas
            confetti.create(canvas, {
                resize: true,
                useWorker: true,
            })({
                particleCount: 100,
                spread: 160,
                origin: { y: 0.6 },
            });
        }
    }
    deactivateConfetti() {
        const confettiContainer = document.getElementById("confetti-container");
        if (confettiContainer) {
            // Remove all child elements (canvas) from the container
            confettiContainer.innerHTML = "";
        }
    }
    updateGameScreen(optionNumber) {
        // this.tutorialText.setVisible(!this.questionPopup.visible);
        // this.closeButton.setVisible(!this.closeButton.visible);
        // this.tutorialTextHeading.setVisible(!this.questionPopup.visible);
        // this.questionPopup.setVisible(!this.questionPopup.visible);
        gtag("event", "game_page", {
            screen_name: "game_page",
        });
        if (optionNumber == 1) {
            this.totalQuestions = 1;
            this.isPicMode = true;
            this.m = 3;
            this.n = 2;
            this.startX = -135;
            this.startY =
                this.questionBox.y -
                    this.questionBox.scaleY * this.questionBox.height * 0.22;
            this.boxScale = 1.58;
            this.boxSize = this.questionBox.scaleX * this.questionBox.width * 0.9;
            this.xOffset = 1.6;
        }
        if (optionNumber == 2) {
            this.m = 3;
            this.n = 2;
            this.startX = -175; // -135
            this.startY =
                this.questionBox.y -
                    this.questionBox.scaleY * this.questionBox.height * 0.22;
            this.boxScale = 0.65;
            this.boxSize = this.questionBox.scaleX * this.questionBox.width * 1.1; // 0.9
            this.xOffset = 1.6;
        }
        if (optionNumber == 3) {
            this.m = 4;
            this.n = 4;
            this.startX = -250;
            this.startY =
                this.questionBox.y -
                    this.questionBox.scaleY * this.questionBox.height * 0.3;
            this.boxSize = this.questionBox.scaleX * this.questionBox.width * 0.3;
            this.boxScale = 1;
        }
        this.isRunning = true;
        this.updateBoxes();
        this.scene.time.delayedCall(1000, () => {
            this.TweenBoxesToCenter();
        });
    }
    SwapBoxes(selectedBoxes, unselectedBoxes) {
        let boxesToInterchangeSelected = [];
        let boxesToInterchangeUnSelected = [];
        let selectedTextBoxes = [];
        let textString = [];
        selectedBoxes.forEach((node, index) => {
            let unselectedBoxCheck = unselectedBoxes[index];
            if (node.boxId == 0 || node.boxId == 2 || node.boxId == 4) {
                textString.push(node.boxId);
                selectedTextBoxes.push(node.boxText.text);
                let index = 0;
                if (node.boxId == 2)
                    index = 1;
                if (node.boxId == 4)
                    index = 2;
                console.log(node.boxText.text, index, "yes");
                let textToUpdate = this.infoAnswers[this.questionNumber - 1][index];
                this.longButtonTextArr[index].setText(textToUpdate);
                this.longButtonTextArr[index].hyperlink =
                    this.checkAnswersWithLinks[this.questionNumber - 1][index];
                console.log(this.correctAnswers[this.questionNumber - 1][index], textToUpdate);
            }
            else {
                textString.push(node.boxId);
                selectedTextBoxes.push(node.boxText.text);
                boxesToInterchangeSelected.push(node);
            }
            if (unselectedBoxCheck.boxId == 0 ||
                unselectedBoxCheck.boxId == 2 ||
                unselectedBoxCheck.boxId == 4) {
                boxesToInterchangeUnSelected.push(unselectedBoxCheck);
            }
            else {
            }
        });
        for (let i = 0; i < boxesToInterchangeSelected.length; i++) {
            this.TweenSwapBoxes(boxesToInterchangeSelected[i], boxesToInterchangeUnSelected[i]);
        }
        this.scene.time.delayedCall(2200, () => {
            this.isNextButtonPressedOk = true;
            unselectedBoxes.forEach((box, j) => {
                box.setAlpha(0);
                box.boxText.setAlpha(0);
                selectedBoxes[j].setAlpha(0);
                selectedBoxes[j].boxText.setAlpha(0);
                if (this.isPicMode) {
                    box.boxImage.setAlpha(0);
                    selectedBoxes[j].boxImage.setAlpha(0);
                }
            });
        });
        this.scene.time.delayedCall(2200, () => {
            // this.isAnimationRunning = false;
            // this.belowText.setTexture("clickBoxReadMore");
            // this.belowText.setVisible(true);
            if (this.submitButtonPhase != "GameEnd") {
                this.submitButton.setVisible(true);
                this.submitButton.setTexture("next");
            }
            // this.belowText.setText("Click on the boxes to read more");
            this.longButtonArr.forEach((node, index) => {
                this.UpdateMask(this.longButtonGraphicsArr[index], node);
                node.setAlpha(1);
                this.longButtonTextArr[index].setAlpha(1);
                this.longButtonTextArr[index].setDepth(11);
            });
        });
    }
    UpdateMask(node, box) {
        let i = 0.1;
        let timer = null;
        timer = this.scene.time.addEvent({
            delay: 25,
            callback: () => {
                if (i > 1) {
                    timer.paused = true;
                    timer.remove();
                    i = 0.1;
                }
                node.fillRoundedRect(box.x - box.scaleX * box.width * 0.5, box.y - 100, box.x + box.scaleX * box.width * i, box.scaleY * box.height * 2.5, 12);
                i += 0.1;
            },
            loop: true,
        });
    }
    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor;
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
        if (/android/i.test(userAgent)) {
            return "Android";
        }
        if (/iPad|iPhone|iPod/.test(userAgent)) {
            return "iOS";
        }
        return "unknown";
    }
    ClearAllMask() {
        this.longButtonArr.forEach((node, index) => {
            this.longButtonGraphicsArr[index].clear();
            // this.longButtonGraphicsArr[index].fillRoundedRect(
            // 	node.x - node.scaleX*node.width*0.5,
            // 	node.y -75 ,
            // 	node.x + node.scaleX*node.width*0,
            // 	node.scaleY*node.height*2.5,
            // 	12
            // );
        });
    }
    TweenBoxesToCenter() {
        this.isAnimationRunning = true;
        let delay = 0;
        let count = 0;
        this.boxArr.forEach((node, index) => {
            this.TweenBoxToCenter(node, delay);
            count++;
            if (count % 2 == 0)
                delay += 500;
        });
        this.scene.time.delayedCall(delay, () => {
            this.isAnimationRunning = false;
            this.resumeTimer();
        });
    }
    TweenBoxOffCenter(box, delay) {
        let orgTargets = [box, box.boxText];
        this.scene.tweens.add({
            targets: orgTargets,
            x: box.x,
            y: box.y,
            duration: 300,
            delay: delay,
            ease: Phaser.Math.Easing.Quadratic.Out,
            onComplete: () => { },
        });
    }
    TweenBoxToCenter(box, delay) {
        let orgTargets = [box, box.boxText];
        this.scene.tweens.add({
            targets: orgTargets,
            x: box.orgPosX,
            y: box.orgPosY,
            duration: 300,
            delay: delay,
            ease: Phaser.Math.Easing.Quadratic.Out,
            onComplete: () => { },
        });
    }
    TweenSwapBoxes(orgBox, swapBox) {
        let swapPos1 = { x: orgBox.x, y: orgBox.y };
        let swapPos2 = { x: swapBox.x, y: swapBox.y };
        let index = 0;
        if (swapBox.boxId == 2)
            index = 1;
        if (swapBox.boxId == 4)
            index = 2;
        let textToUpdate = this.infoAnswers[this.questionNumber - 1][index];
        this.longButtonTextArr[index].setText(textToUpdate);
        this.longButtonTextArr[index].hyperlink =
            this.checkAnswersWithLinks[this.questionNumber - 1][index];
        console.log(this.correctAnswers[this.questionNumber - 1][index], textToUpdate);
        let orgTargets = [orgBox, orgBox.boxText];
        if (this.isPicMode)
            orgTargets = [orgBox, orgBox.boxText, orgBox.boxImage];
        this.scene.tweens.add({
            targets: orgTargets,
            x: swapPos2.x,
            y: swapPos2.y,
            duration: 300,
            delay: 1000,
            ease: "Linear",
            onComplete: () => { },
        });
        let swapTargets = [swapBox, swapBox.boxText];
        if (this.isPicMode)
            swapTargets = [swapBox, orgBox.boxText, swapBox.boxImage];
        this.scene.tweens.add({
            targets: swapTargets,
            x: swapPos1.x,
            y: swapPos1.y,
            duration: 300,
            delay: 1000,
            ease: "Linear",
            onComplete: () => { },
        });
    }
    updateBoxes() {
        let style1 = {
            font: "35px Arial",
        };
        let hyperLinkNum = 0;
        for (let i = 0; i < this.m; i++) {
            for (let j = 0; j < this.n; j++) {
                let x = this.startX + (j * this.boxSize * 0.7) / this.xOffset;
                let y = this.startY + (i * this.boxSize * 0.6) / this.yOffset;
                let tweenXpos = this.startX + 25 + (j * this.boxSize * 0.92) / this.xOffset;
                let box = this.scene.add
                    .sprite(x, y, "button1")
                    .setScale(this.boxScale)
                    .setInteractive();
                style1 = {
                    font: "38px Arial",
                    align: "center",
                    wordWrap: { width: box.width * 0.5 },
                };
                let wordsArrangeIndex = this.m > this.n
                    ? i + j * this.noOfWordsToSelect
                    : j + i * this.noOfWordsToSelect;
                let boxText = this.scene.add
                    .text(x, y, this.randomizedArray[wordsArrangeIndex], style1)
                    .setOrigin(0.5);
                boxText.setFontFamily("GameFontBold");
                style1 = { font: "15px Arial" };
                boxText.setColor(this.colorCode.unSelectedBoxTextHex);
                box.isSelected = false;
                box.boxId = i * this.n + j;
                const currentQuestionAnswers = this.correctAnswers[this.questionNumber - 1];
                const answerIndex = currentQuestionAnswers.indexOf(this.randomizedArray[wordsArrangeIndex]);
                box.textId = 0;
                if (answerIndex !== -1) {
                    box.textId = answerIndex;
                }
                if (this.isPicMode) {
                    let boxImage = this.scene.add
                        .sprite(box.x, box.y, this.imageOptionsArr[wordsArrangeIndex])
                        .setScale(box.scale * 0.9)
                        .setDepth(11);
                    box.boxImage = boxImage;
                }
                if (this.isPicMode)
                    boxText.setVisible(false);
                if (j == 0) {
                    let longButton = this.scene.add
                        .sprite(x + box.scaleX * box.width * 0.56, y, "longButton1")
                        .setScale(box.scale)
                        .setDepth(4);
                    style1 = {
                        font: "42px Arial",
                        align: "center",
                        wordWrap: { width: longButton.width * 0.55 },
                    };
                    let longButtonText = this.scene.add
                        .text(longButton.x - box.scaleX * box.width * 0.0, longButton.y, "Read More\tReadMore\tReadMore\nReadMore", style1)
                        .setOrigin(0.5, 0.5)
                        .setDepth(4)
                        .setInteractive();
                    longButtonText.setColor(this.colorCode.longButtonTextHex);
                    longButtonText.setFontFamily("GameFontMedium");
                    longButtonText.setAlign("center");
                    let shape = this.scene.make.graphics({});
                    shape.fillStyle(0xff0000, 1.0); // Set fill color (red) and opacity (1.0)
                    shape.fillRoundedRect(longButton.x - longButton.scaleX * longButton.width * 1.3, longButton.y - 75, longButton.x + longButton.scaleX * longButton.width * 0, longButton.scaleY * longButton.height * 2.5, 12);
                    var mask = shape.createGeometryMask();
                    this.longButtonGraphicsArr.push(shape);
                    // longButton.setTint(this.colorCode.longButtonHex);
                    longButton.setMask(mask);
                    longButtonText.hyperlink =
                        this.checkAnswersWithLinks[this.questionNumber - 1][box.textId];
                    longButtonText.on("pointerup", (pointer) => {
                        let hyperlink = longButtonText.hyperlink;
                        window.open(hyperlink, "_blank");
                    });
                    hyperLinkNum++;
                    this.longButtonArr.push(longButton);
                    this.longButtonTextArr.push(longButtonText);
                    longButton.setAlpha(0);
                    longButtonText.setAlpha(0);
                }
                // box.setTint(this.colorCode.unSelectedBoxHex);
                box.orgPosX = box.x;
                box.orgPosY = box.y;
                if (box.boxId % 2 == 0)
                    box.x -= 1000;
                else
                    box.x += 1000;
                boxText.x = box.x;
                // box.orgOutOfScreenPosX = box.x;
                // box.orgOutOfScreenPosY = box.y;
                box.tweenXpos = box.x;
                box.boxText = boxText;
                box.isCorrectAnswered = false;
                box.isFlipping = false;
                box.orgScale = box.scale;
                box.flipZoom = 1.2;
                box.isFlipEnabled = true;
                box.on("pointerup", () => this.onBoxClick(box, boxText));
                this.boxArr.push(box);
                this.boxTextArr.push(boxText);
            }
        }
    }
    findLink(text, obj) {
        for (const key in obj) {
            if (text.includes(key)) {
                return obj[key];
            }
        }
        return null;
    }
    updateStopwatch() {
        var _a;
        if (this.isRunning) {
            if (this.elapsedTime <= 0) {
                (_a = this.scalingTimer) === null || _a === void 0 ? void 0 : _a.stop();
                this.timeText.setColor(this.originalTimeTextColor);
                this.timeText.setScale(1);
                this.scene.time.delayedCall(6000, () => {
                    this.endGameScreen();
                });
                this.boxArr.forEach((node, index) => {
                    if (this.correctAnswers[this.questionNumber - 1].includes(this.boxTextArr[index].text)) {
                        this.boxArr[index].isSelected = true;
                    }
                    else {
                        this.boxArr[index].isSelected = false;
                    }
                });
                const selectedBoxes = this.boxArr.filter((box) => box.isSelected);
                const unselectedBoxes = this.boxArr.filter((box) => !box.isSelected);
                this.shakeBoxesSequentially(selectedBoxes, unselectedBoxes, true);
                // this.submitButtonText.setText('Next');
                this.submitButtonPhase = "GameEnd";
                this.timer.paused = true;
                this.isRunning = false;
            }
            else {
                this.elapsedTime -= 100; // Add 100ms
                this.updateTimeDisplay();
            }
            // if(this.elapsedTime > 0)
            // 	this.elapsedTime -= 100; // Add 100ms
            // 	this.updateTimeDisplay();
        }
    }
    resetStopwatch() {
        this.elapsedTime = 60000 * 2;
        this.isRunning = false;
        this.updateTimeDisplay();
    }
    updateTimeDisplay() {
        const totalSeconds = Math.floor(this.elapsedTime / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const timeString = `${this.pad(minutes)}:${this.pad(seconds)}`;
        this.timeText.setText(timeString);
        if (this.elapsedTime < 10000 && !this.isTimerRed) {
            this.isTimerRed = true;
            this.timeText.setColor("#ff0000"); // Red
            this.scalingTimer = this.scene.tweens.add({
                targets: this.timeText,
                scale: { from: 1, to: 1.2 },
                duration: 200,
                yoyo: true,
                repeat: -1,
                onComplete: () => {
                    this.scene.tweens.add({
                        targets: this.timeText,
                        scale: 1,
                        duration: 200,
                        repeat: 0,
                    });
                },
            });
        }
        else if (this.elapsedTime >= 10000) {
            this.timeText.setColor(this.originalTimeTextColor);
            this.isTimerRed = false;
            this.timeText.setScale(1);
        }
    }
    pad(number) {
        return number.toString().padStart(2, "0");
    }
    endGameScreen() {
        this.setVisibleAll(false);
        this.belowText.setVisible(false);
        if (this.score >= 4)
            this.triggerConfetti();
        this.longButtonArr.forEach((node, index) => {
            node.setAlpha(0);
            this.longButtonTextArr[index].setAlpha(0);
        });
        this.endInstructionPopup.setVisible(true);
        const endMessage = this.score > 0
            ? "Congratulations!\n\nYou Answered\n\n"
            : "Better luck next\ntime!\n\n";
        this.endText1.setText(endMessage).setVisible(true);
        this.endText1.setVisible(true);
        this.endText2.setVisible(true);
        // this.twitterLogo.setVisible(true);
        // this.facebookLogo.setVisible(true);
        // this.instagramLogo.setVisible(true);
        // if (this.score == this.totalQuestions) this.endText3.setVisible(true);
        // this.EndnextButton.setVisible(true);
        //  this.feedbackButton.setVisible(true);
        this.endText2.setText(this.score + "/" + this.totalQuestions);
        // this.feedbackButton.setVisible(true);
        // if(this.gameTry <2 ){
        // 	this.playAnotherRoundButton.setVisible(true);
        // }
        // if(this.isPicMode){
        // 	this.playAnotherRoundButton.setVisible(false);
        // }
        const scoreString = this.score + "/" + this.totalQuestions;
        const scorePercent = Math.round((this.score / this.totalQuestions) * 100);
        gtag("event", "game_summary", {
            event_category: "gameplay",
            event_label: "Level Completed",
            score: scoreString,
            score_percentage: scorePercent,
            game_name: "trends",
            screen_name: "game_page",
        });
        return;
    }
    generateOptions() {
        let correctAnswersForQuestion = this.correctAnswers[this.questionNumber - 1];
        let correctAnswers = this.correctAnswers[this.questionNumber - 1];
        let wrongAnwers = this.wrongAnwers[this.questionNumber - 1];
        let options = new Set(correctAnswersForQuestion);
        options = [...correctAnswers, ...wrongAnwers];
        if (true) {
            let correctAnswers = this.picAnswerArr;
            let wrongAnwers = this.picWrongAnswerArr;
            this.imageOptionsArr = [...correctAnswers, ...wrongAnwers];
        }
        let imageArr = this.imageOptionsArr;
        for (let i = options.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [options[i], options[j]] = [options[j], options[i]];
            [imageArr[i], imageArr[j]] = [imageArr[j], imageArr[i]];
        }
        this.imageOptionsArr = imageArr;
        return options;
    }
    DeselectAll() {
        this.totalBoxsClicked = 0;
        this.updateSubmitButton();
        this.boxArr.forEach((box, index) => {
            if (!box.isCorrectAnswered) {
                box.isSelected = false;
                // box.clearTint();
                // this.boxTextArr[index].setColor('#000000');
                // box.setTint(this.colorCode.unSelectedBoxHex);
                box.setTexture("button1");
                this.boxTextArr[index].setColor(this.colorCode.unSelectedBoxTextHex);
            }
        });
    }
    onBoxClick(box, boxText) {
        if (this.isAnimationRunning)
            return;
        if ((this.totalBoxsClicked === this.noOfWordsToSelect && !box.isSelected) ||
            box.isCorrectAnswered) {
            return;
        }
        box.isSelected = !box.isSelected;
        if (box.isSelected) {
            // box.setTint(this.colorCode.selectedBoxHex);
            // boxText.setColor(this.colorCode.selectedBoxTextHex);
            box.setTexture("button21");
            this.totalBoxsClicked++;
        }
        else {
            // box.setTint(this.colorCode.unSelectedBoxHex);
            // 	boxText.setColor(this.colorCode.unSelectedBoxTextHex);
            box.setTexture("button1");
            this.totalBoxsClicked--;
        }
        this.updateSubmitButton();
    }
    updateSubmitButton() {
        if (this.totalBoxsClicked === this.noOfWordsToSelect) {
            this.submitButton.setAlpha(1);
            this.submitButtonText.setAlpha(1);
        }
        else {
            this.submitButton.setAlpha(0.5);
            this.submitButtonText.setAlpha(0.5);
        }
    }
    DisableAllBoxes() {
        this.boxArr.forEach((box) => {
            box.isCorrectAnswered = true;
        });
    }
    checkAnswers(selectedAnswers) {
        // Ensure the questionIndex is valid
        if (this.questionNumber < 0 ||
            this.questionNumber >= this.questionArr.length + 1) {
            return false;
        }
        // Get the correct answers for the current question
        const correctAnswersForQuestion = this.correctAnswers[this.questionNumber - 1];
        const correctSelectedAnswers = selectedAnswers.filter((answer) => correctAnswersForQuestion.includes(answer));
        const countCorrectAnswers1 = correctSelectedAnswers.length;
        if (countCorrectAnswers1 == 2 && this.noOfMistakesRemaining == 2) {
            this.belowText.setVisible(true);
            this.belowText.setTexture("you_are_close");
            // this.belowText.setText("You are close. Try again");
        }
        // Check if the number of selected answers is correct
        if (selectedAnswers.length !== 3) {
            // if(selectedAnswers.length == 2) 		this.belowText.setText("You are close. Try again");
            return false;
        }
        // Check if all selected answers are in the correct answers array
        const allCorrect = selectedAnswers.every((answer) => correctAnswersForQuestion.includes(answer));
        return allCorrect;
    }
    OnNextButtonPressed() {
        if (!this.isNextButtonPressedOk)
            return;
        this.isNextButtonPressedOk = false;
        this.belowText.setVisible(false);
        this.questionNumber++;
        this.isButtonPressed = false;
        this.deactivateConfetti();
        // this.submitButtonText.setText("Submit");
        this.submitButton.setTexture("buttonCircle");
        this.submitButtonPhase = "";
        this.gameHintHeadingText.x = 0;
        this.DeselectAll();
        setTimeout(() => {
            // this.gameHintHeadingText.setText(this.questionArr[this.questionNumber - 1]);
            this.gameHintHeadingText.setText(this.questionArr[this.questionNumber - 1]);
            if (this.questionArr[this.questionNumber - 1].length > 20) {
                this.gameHintHeadingText.setFontSize(45);
            }
            else {
                this.gameHintHeadingText.setFontSize(60);
            }
            gtag("event", this.questionNumber + "_page", {
                screen_name: "game_page",
            });
            this.totalBoxsClicked = 0;
            this.longButtonArr.forEach((node, index) => {
                node.setAlpha(0);
                this.longButtonTextArr[index].setAlpha(0);
            });
            this.ClearAllMask();
            this.mistakeDotsArr.forEach((node) => {
                node.setVisible(true);
            });
            this.noOfMistakesRemaining = 2;
            this.boxArr.forEach((box) => {
                box.isSelected = false;
                box.isCorrectAnswered = false;
                // box.setTint(this.colorCode.unSelectedBoxHex);
                // box.boxText.setColor(this.colorCode.unSelectedBoxTextHex);
                box.setTexture("button1");
                box.setPosition(box.tweenXpos, box.orgPosY);
                box.boxText.setPosition(box.x, box.y);
                box.setAlpha(1);
                box.boxText.setAlpha(1);
                this.TweenBoxesToCenter();
            });
            this.randomizedArray = this.generateOptions();
            this.boxTextArr.forEach((node, index) => {
                node.setText(this.randomizedArray[index]);
                // Get the current question's correct answers
                const currentQuestionAnswers = this.correctAnswers[this.questionNumber - 1];
                // Find the position of this text in the current question's correct answers
                const answerIndex = currentQuestionAnswers.indexOf(this.randomizedArray[index]);
                // If found in correct answers, set textId to that position
                if (answerIndex !== -1) {
                    this.boxArr[index].textId = answerIndex;
                }
            });
        }, 0);
    }
    pauseTimer() {
        this.timer.paused = true;
        this.isRunning = false;
    }
    // Add a method to resume timer
    resumeTimer() {
        this.timer.paused = false;
        this.isRunning = true;
    }
    checkAnswer() {
        if (this.submitButtonPhase == "Done") {
            gtag("event", "done_btn", {
                screen_name: "game_page",
            });
            this.endGameScreen();
            return;
        }
        else if (this.submitButtonPhase == "Next") {
            gtag("event", "next_btn", {
                screen_name: "game_page",
            });
            // this.resumeTimer();
            this.OnNextButtonPressed();
            return;
        }
        if (this.totalBoxsClicked !== this.noOfWordsToSelect)
            return;
        if (this.isButtonPressed)
            return;
        this.isButtonPressed = true;
        this.pauseTimer();
        const selectedBoxes = this.boxArr.filter((box) => box.isSelected);
        const unselectedBoxes = this.boxArr.filter((box) => !box.isSelected);
        const selectedWords = selectedBoxes.map((box) => this.boxTextArr[this.boxArr.indexOf(box)].text);
        let isCorrect = this.checkAnswers(selectedWords);
        this.submitButton.play("button_click");
        if (isCorrect) {
            this.score++;
            this.triggerConfetti();
            let congratsAudio = document.getElementById("congratsAudio");
            if (congratsAudio) {
                congratsAudio.loop = false;
                congratsAudio.volume = 0.5;
                if (this.isSoundOn)
                    congratsAudio
                        .play()
                        .catch((error) => console.error("Error playing audio:", error));
            }
            else {
                console.error("Audio element not found");
            }
            gtag("event", "level_complete", {
                event_category: "gameplay",
                event_label: "Level Completed",
                score: this.score,
                screen_name: "game_page",
                game_name: "trends",
            });
        }
        else {
            let wrongAudio = document.getElementById("wrongAudio");
            if (wrongAudio) {
                wrongAudio.loop = false;
                wrongAudio.volume = 0.5;
                if (this.isSoundOn)
                    wrongAudio
                        .play()
                        .catch((error) => console.error("Error playing audio:", error));
            }
            else {
                console.error("Audio element not found");
            }
        }
        this.shakeBoxesSequentially(selectedBoxes, unselectedBoxes, isCorrect);
        this.isAnimationRunning = true;
        if (isCorrect) {
            if (this.totalQuestions === this.questionNumber) {
                this.submitButtonText.setText("Done");
                this.DisableAllBoxes();
                this.submitButtonPhase = "Done";
                return;
            }
            // this.submitButtonText.setText('Next');
            this.scene.time.delayedCall(500, () => {
                this.submitButton.setVisible(false);
            });
            this.submitButtonPhase = "Next";
        }
        else {
            setTimeout(() => {
                if (this.noOfMistakesRemaining != 0)
                    this.isButtonPressed = false;
                if (this.noOfMistakesRemaining != 1)
                    this.DeselectAll();
                this.noOfMistakesRemaining--;
                if (this.noOfMistakesRemaining >= 0) {
                    this.belowText.setVisible(false);
                    this.scene.tweens.add({
                        targets: this.mistakeDotsArr[this.noOfMistakesRemaining],
                        scale: 0.5,
                        duration: 300,
                        ease: "Linear",
                        yoyo: true,
                        repeat: 0,
                        onComplete: () => {
                            if (this.noOfMistakesRemaining != 0)
                                this.isAnimationRunning = false;
                            this.mistakeDotsArr[this.noOfMistakesRemaining].setVisible(false);
                        },
                    });
                }
                if (this.noOfMistakesRemaining == 0) {
                    this.pauseTimer();
                    let congratsAudio = document.getElementById("congratsAudio");
                    this.scene.time.delayedCall(500, () => {
                        if (congratsAudio) {
                            congratsAudio.loop = false;
                            congratsAudio.volume = 0.5;
                            if (this.isSoundOn)
                                congratsAudio
                                    .play()
                                    .catch((error) => console.error("Error playing audio:", error));
                        }
                        else {
                            console.error("Audio element not found");
                        }
                    });
                    this.boxArr.forEach((node, index) => {
                        if (this.correctAnswers[this.questionNumber - 1].includes(this.boxTextArr[index].text)) {
                            this.boxArr[index].isSelected = true;
                        }
                        else {
                            this.boxArr[index].isSelected = false;
                        }
                    });
                    const selectedBoxes = this.boxArr.filter((box) => box.isSelected);
                    const unselectedBoxes = this.boxArr.filter((box) => !box.isSelected);
                    this.shakeBoxesSequentially(selectedBoxes, unselectedBoxes, true);
                    // this.submitButtonText.setText('Next');
                    this.submitButtonPhase = "Next";
                    if (this.noOfMistakesRemaining <= 1 &&
                        this.totalQuestions === this.questionNumber) {
                        this.submitButtonText.setText("Done");
                        this.DisableAllBoxes();
                        this.submitButtonPhase = "Done";
                    }
                }
            }, 2000);
        }
    }
    setVisibleAll(bool) {
        this.gameHintHeadingText.setVisible(bool);
        this.timeText.setVisible(bool);
        this.timerBG.setVisible(bool);
        this.boxArr.forEach((box) => {
            box.setVisible(bool);
            box.boxText.setVisible(bool);
        });
        this.mistakesText.setVisible(bool);
        this.mistakeDotsArr.forEach((node) => {
            node.setVisible(bool);
        });
        this.submitButton.setVisible(bool);
        // this.submitButtonText.setVisible(bool);
        this.longButtonArr.forEach((node, index) => {
            node.setAlpha(bool ? 1 : 0);
            this.longButtonTextArr[index].setAlpha(bool ? 1 : 0);
        });
    }
    shakeBoxesSequentially(boxes, unselectedBoxes, isCorrect) {
        let delay = 0;
        const delayIncrement = 200;
        const shakeDuration = 200;
        let counter = 0;
        boxes.forEach((box) => {
            this.scene.tweens.add({
                targets: box,
                x: isCorrect ? box.x : box.x + 20,
                y: isCorrect ? box.y - 5 : box.y,
                duration: shakeDuration,
                yoyo: true,
                repeat: 1,
                delay: delay,
                onComplete: () => {
                    if (isCorrect) {
                        box.isSelected = false;
                        box.isCorrectAnswered = true;
                        // box.setTint(this.colorCode.correctAnswerBoxHex); // Green tint for correct
                        box.setTexture("button31");
                        counter++;
                        if (counter == 3)
                            this.SwapBoxes(boxes, unselectedBoxes);
                    }
                    else {
                        this.resumeTimer();
                        // box.setTint(this.colorCode.selectedBoxHex); // Red tint for incorrect
                        box.setTexture("button1");
                    }
                },
            });
            this.scene.tweens.add({
                targets: box.boxText,
                x: isCorrect ? box.x : box.x + 20,
                y: isCorrect ? box.y - 5 : box.y,
                duration: shakeDuration,
                yoyo: true,
                repeat: 1,
                delay: delay,
                onComplete: () => {
                    if (isCorrect) {
                        // box.setTint(this.colorCode.correctAnswerBoxHex);
                        // box.boxText.setColor(this.colorCode.correctAnswerBoxTextHex);
                        box.setTexture("button31");
                    }
                    else {
                    }
                },
            });
            if (this.isPicMode) {
                this.scene.tweens.add({
                    targets: box.boxImage,
                    x: isCorrect ? box.x : box.x + 20,
                    y: isCorrect ? box.y - 5 : box.y,
                    duration: shakeDuration,
                    yoyo: true,
                    repeat: 1,
                    delay: delay,
                    onComplete: () => { },
                });
            }
            delay += delayIncrement;
        });
    }
    update(time, delta) {
        if (this.isRunning) {
            this.elapsedTime -= delta;
            this.updateTimeDisplay();
        }
    }
    resizeAndRepositionElements(w, h) {
        const width = w / this.questionBox.width;
        const height = h / this.questionBox.height;
        // this.questionBox.setScale(width > height ? width : height);
    }
}
